import useWhitelabel from "../../hooks/useWhitelabel";

const Startup = () => {
    const {currentWhitelabel} = useWhitelabel();

    return <></>;
}
export default Startup;